/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Menu, MenuItem, Button } from '@material-ui/core';
import AccountPlusIcon from 'mdi-react/AccountPlusIcon';
import AccountMinusIcon from 'mdi-react/AccountMinusIcon';
import AccountMultiplePlusIcon from 'mdi-react/AccountMultiplePlusIcon';
import EyeIcon from 'mdi-react/EyeIcon';
import DeleteIcon from 'mdi-react/DeleteIcon';
import { connect } from 'react-redux';
import { Modal, Select, Spin } from 'antd';

import { assignLeadRequest } from '../redux/actions/assign_lead.actions';
import { updateTradeLead } from '../requests/assign_trade_lead_request';
import { updateWWYMLead } from '../requests/assign_wwym_lead_request';
import { updateOnAssignLead } from '../requests/assign_lead_request';
import { message_success } from '../../../../components/Message';
import { deleteLeadRequest } from '../redux/actions/delete_lead.actions';
import { debounce, get, getVal } from '../../../../shared/helpers';
import { getLeadsRequest } from '../redux/actions/get_leads.actions';
import { getUsersList } from '../redux/actions/get_users_list.actions';
import { leadManageChangeLeadsStatusRequest } from '../redux/actions/lead_manage_lead_status.actions';
import { LEAD_STATUS } from '../../constants/leadStatuses';

import './styles/actionsLead.scss';

const { Option } = Select;


class ActionsLead extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            visibleModalAssignLead: false,
            visibleModalDeleteLead: false,
            visibleModalScrap: false,
            assignUserId: null,
        };
    }


    showModalAssignLead = () => {
        this.setState({
            visibleModalAssignLead: true,
            anchorEl: null,
        });
    };

    updateLeadData = () => {
        this.props.getLeadsRequest();
        this.props.updateCheckBoxState();
    }


    handleOkAssignLead = () => {
        this.props.setIsUpdating?.(true);

        if (this.props.lead_list.length === 0) {
            updateOnAssignLead(this.state.assignUserId, this.props.lead_id)
                .then(() => {
                    this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                    this.props.setIsUpdating?.(false);

                    message_success('Assigned successfully!');
                });
        } else {
            this.props.lead_list.map(function (l, j) {
                updateOnAssignLead(this.state.assignUserId, l.id).then(() => {
                    if (this.props.lead_list.length === (j + 1)) {
                        this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                        this.props.setIsUpdating?.(false);
                        message_success('Assigned successfully!');
                    }
                });
            }, this);
        }
    };


    handleCancelAssignLead = () => {
        this.setState({
            visibleModalAssignLead: false,
        });
    };

    showModalDeleteLead = () => {
        this.setState({
            visibleModalDeleteLead: true,
            anchorEl: null,
        });
    };


    handleOkDeleteLead = () => {
        if (this.props.lead_list.length === 0) {
            this.props.deleteLeadRequest(this.props.lead_id);
            this.setState({ visibleModalDeleteLead: false }, this.updateLeadData);
        } else {
            this.props.lead_list.map(function (l, j) {
                this.props.deleteLeadRequest(l.id);

                if (this.props.lead_list.length === (j + 1)) {
                    this.setState({ visibleModalDeleteLead: false }, this.updateLeadData);
                }
            }, this);
        }
    };


    handleCancelDeleteLead = () => {
        this.setState({ visibleModalDeleteLead: false });
    };

    updateToWWYM = () => {
        this.props.setIsUpdating?.(true);

        if (this.props.lead_list.length === 0) {
            updateWWYMLead(this.props.currentUserId, this.props.lead_id)
                .then(() => {
                    this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                    this.props.setIsUpdating?.(false);
                    message_success('Assigned successfully!');
                });
            this.setState({ anchorEl: null });
        } else {
            this.props.lead_list.map(function (l, j) {
                updateWWYMLead(this.props.currentUserId, l.id).then(() => {
                    if (this.props.lead_list.length === (j + 1)) {
                        this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                        this.props.setIsUpdating?.(false);
                        message_success('Assigned successfully!');
                    }
                });
            }, this);
        }
    };


    updateToTrade = () => {
        this.props.setIsUpdating?.(true);

        if (this.props.lead_list.length === 0) {
            updateTradeLead(this.props.currentUserId, this.props.lead_id)
                .then(() => {
                    this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                    this.props.setIsUpdating?.(false);
                    message_success('Assigned successfully!');
                });
            this.setState({ anchorEl: null });
        } else {
            this.props.lead_list.map(function (l, j) {
                updateTradeLead(this.props.currentUserId, l.id).then(() => {
                    if (this.props.lead_list.length === (j + 1)) {
                        this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                        this.props.setIsUpdating?.(false);
                        message_success('Assigned successfully!');
                    }
                });
            }, this);
        }
    };

    handleAssignLeadToMe = (event) => {
        this.props.setIsUpdating?.(true);

        if (this.props.lead_list.length === 0) {
            updateOnAssignLead(event.target.innerText === 'Unassign' ? 'undefined' : this.props.currentUserId, this.props.lead_id)
                .then(() => {
                    this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                    this.props.setIsUpdating?.(false);
                    message_success('Assigned successfully!');
                });
            this.setState({ anchorEl: null });
        } else {
            this.props.lead_list.map(function (l, j) {
                updateOnAssignLead(event.target.innerText === 'Unassign' ? 'undefined' : this.props.currentUserId, l.id).then(() => {
                    if (this.props.lead_list.length === (j + 1)) {
                        this.setState({ visibleModalAssignLead: false }, this.updateLeadData);
                        this.props.setIsUpdating?.(false);
                        message_success('Assigned successfully!');
                    }
                });
            }, this);
        }
    };

    handleClick = (event) => this.setState({ anchorEl: event.currentTarget });

    handleClose = () => this.setState({ anchorEl: null });


    handleChange = (value) => {
        this.setState({ assignUserId: value });
    };

    searchUsers = (value) => {
        this.props.getUsersList(value);
        this.forceUpdate();
    };

    debouncedSearchUsers = debounce(this.searchUsers, 500);

    handleSearchUsers = (value) => {
        this.debouncedSearchUsers(value);
    };

    checkPermissionForDeleteLead = () => {
        const allowedGroupsForDeleteLead = [
            // admin group id
            '5b6a9ee2ba52006858939023',
            // super user group id
            '5b6a9ee2ba52006858939024',
            // call_center_manager_id
            '5bb1d5980495fed3883c07ac',
        ];

        const accessForDeleteLead = getVal(this.props.current_user, 'groups').some((group) => allowedGroupsForDeleteLead.includes(group._id));

        return accessForDeleteLead;
    };


    checkPermissionForTrade = () => {
        const allowedGroupsForTradeLead = [
            // admin group id
            '5b6a9ee2ba52006858939023',
            // super user group id
            '5b6a9ee2ba52006858939024',
            // trade
            '5f477ffa143ca00bd466c4ec',
        ];

        return getVal(this.props.current_user, 'groups').some((group) => allowedGroupsForTradeLead.includes(group._id));
    };

    changeLeadStatus = (status_id) => {
        // Change to Pending (Trade):
        // On No Buy List
        // Mileage Too High
        // Bike Too Old
        if (this.props.lead_list.length === 0) {
            this.props.leadManageChangeLeadsStatusRequest(this.props.lead_id, status_id);
        } else {
            const _self = this;
            const list = [];
            this.props.lead_list.map(function (l, j) {
                list.push(l.id);
                _self.props.leadManageChangeLeadsStatusRequest(l.id, status_id);

                if (this.props.lead_list.length === (j + 1)) {
                    list.map(function (k) {
                        this.props.leadManageChangeLeadsStatusRequest(k, status_id);
                    }, this);
                }
            }, this);
        }
    };

    setScrapeBikeStatus = () => {
        const { lead_id, leadManageChangeLeadsStatusRequest: leadManageChangeLeadsStatusReq } = this.props;

        leadManageChangeLeadsStatusReq(lead_id, LEAD_STATUS.pendingTrade, { lead_pot: 'Black' });
    };

     toggleScrapConfirmModal = () => {
         this.handleClose();

         this.setState((prevState) => ({
             ...prevState,
             visibleModalScrap: !prevState.visibleModalScrap,
         }));
     }

     render() {
         const {
             anchorEl, visibleModalAssignLead, visibleModalDeleteLead, visibleModalScrap,
         } = this.state;
         const {
             lead_pot, is_trade, lead_list, lead_profile_access, fetching_users, users, lead_id
         } = this.props;

         return (
             <>
                 <Button
                     aria-owns={anchorEl ? 'simple-menu' : undefined}
                     aria-haspopup="true"
                     onClick={this.handleClick}
                     style={{ minWidth: 0 }}
                 >
                     ...
                 </Button>
                 {
                     Boolean(anchorEl)
                    && (
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}
                        >
                            <MenuItem
                                onClick={() => this.changeLeadStatus(is_trade ? '5f92fded338def1a9607ae36' : '5beabf6166676f89160edfc3')}
                                className="menu-item-on-no-buy-list"
                            >
                                <span>On No Buy List</span>
                            </MenuItem>
                            {lead_pot !== 'Black' && (
                                <MenuItem
                                    onClick={this.toggleScrapConfirmModal}
                                    className="menu-item-scrap"
                                >
                                    <span>Scrap</span>
                                </MenuItem>
                            )}
                            {lead_pot !== 'Green'
                                && (
                                    <MenuItem
                                        onClick={() => this.changeLeadStatus(is_trade
                                            ? '5f92fb12338def1a9607ae34'
                                            : '5beabef666676f89160edfbf')
                                        }
                                        className="menu-item-high-mileage"
                                    >
                                        <span>High Mileage</span>
                                    </MenuItem>
                                )
                            }
                            {lead_pot !== 'Green'
                                && (
                                    <MenuItem
                                        onClick={() => this.changeLeadStatus(is_trade
                                            ? '5f92fafd338def1a9607ae33'
                                            : '5beabf6166676f89160edfc0')
                                        }
                                        className="menu-item-bike-too-old"
                                    >
                                        <span>Bike Too Old</span>
                                    </MenuItem>
                                )
                            }

                            {(is_trade)
                                && (
                                    <MenuItem
                                        onClick={() => this.changeLeadStatus('5f7f248cf0c43201c2a7192c')}
                                        className="menu-item-trade-not-want"
                                    >
                                        <span>Trade - Do Not Want</span>
                                    </MenuItem>
                                )}

                            <MenuItem onClick={this.handleAssignLeadToMe}>
                                <span>Assign to Me</span>
                                <AccountPlusIcon className="menu-item-icon" />
                            </MenuItem>


                            <MenuItem onClick={this.showModalAssignLead}>
                                <span>Assign to User</span>
                                <AccountMultiplePlusIcon className="menu-item-assign-icon" />
                            </MenuItem>

                            <MenuItem onClick={this.handleAssignLeadToMe}>
                                <span>Unassign</span>
                                <AccountMinusIcon className="menu-item-icon" />
                            </MenuItem>

                            {lead_list.length === 0
                                && (
                                    <Link
                                        to={!lead_profile_access
                                            ? { pathname: `/Leads/Lead_profile/${lead_id}` }
                                            : { pathname: '' }
                                        }
                                    >
                                        <MenuItem
                                            onClick={this.handleClose}
                                            className="menu-item-view-access"
                                        >
                                            <span>{!lead_profile_access ? 'View' : 'No Access Rights'}</span>
                                            <EyeIcon className="menu-item-icon" />
                                        </MenuItem>
                                    </Link>
                                )}


                            {this.checkPermissionForDeleteLead()
                                && (
                                    <MenuItem
                                        onClick={this.showModalDeleteLead}
                                        className="menu-item-delete"
                                    >
                                        <span>Delete</span>
                                        <DeleteIcon className="menu-item-icon" />
                                    </MenuItem>
                                )
                            }
                        </Menu>
                    )
                 }

                 <Modal
                     title="Assign lead to user"
                     maskClosable
                     visible={visibleModalAssignLead}
                     onOk={this.handleOkAssignLead}
                     onCancel={this.handleCancelAssignLead}
                 >
                     <p style={{ marginBottom: 15 }}>Select user from the list:</p>

                     <Select
                         showSearch
                         allowClear
                         id="assignUser"
                         style={{ width: '100%' }}
                         filterOption={false}
                         notFoundContent={fetching_users ? <Spin size="small" /> : 'Users not Found'}
                         placeholder="Select a person"
                         onSearch={this.handleSearchUsers}
                         onChange={this.handleChange}
                         loading={fetching_users}
                     >
                         {
                             users && users.filter((u) => u.ref_user_status === '5bbb09fb60dc39407f5623aa').map((user) => (
                                 <Option value={user._id} key={user._id}>
                                     {`${user.person && user.person.first_name} ${user.person && user.person.last_name}`}
                                 </Option>
                             ))
                         }
                     </Select>
                 </Modal>

                 <Modal
                     title="Delete lead"
                     visible={visibleModalDeleteLead}
                     onOk={this.handleOkDeleteLead}
                     okText="Delete"
                     okType="danger"
                     onCancel={this.handleCancelDeleteLead}
                 >
                     <p>Are you sure want to delete lead?</p>
                 </Modal>
                 <Modal
                     title="Scrap Bike"
                     visible={visibleModalScrap}
                     onOk={this.setScrapeBikeStatus}
                     okText="Confirm"
                     onCancel={this.toggleScrapConfirmModal}
                 >
                     <p>Are you sure you want to mark this Lead as "Scrap"?</p>
                 </Modal>
             </>
         );
     }
}

ActionsLead.propTypes = {
    setIsUpdating: PropTypes.func,
};

const mapStateToProps = (state) => ({
    currentUserId: get(state.App, 'App_content.user._id'),
    users: state.Leads.Leads_manage.modal_data.users.data,
    fetching_users: state.Leads.Leads_manage.modal_data.users.fetching_users,
    filters: state.Leads.Leads_manage.filters,
    pagination: state.Leads.Leads_manage.pagination,
    current_user: state.App.App_content.user,
});

export default connect(mapStateToProps, {
    assignLeadRequest,
    deleteLeadRequest,
    getLeadsRequest,
    getUsersList,
    leadManageChangeLeadsStatusRequest,
})(ActionsLead);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/components/ActionsLead.js